import i18n from '@/utils/i18n'
import type { Profile } from '@/types/user'
import { isCustomerUser, isContractorUser } from '@/utils/access'

/** Продуктовые названия ролей на текущем языке (см. SPECIFICATION_ADMIN —
 *  глоссарий). i18n-backed: ключи `role.*` в локалях. Вызывающий компонент
 *  должен ре-рендериться при смене языка (useTranslation у вызывающего). */
export function roleDisplayName(profile: Profile | null | undefined): string {
  if (!profile) return '—'
  const { role } = profile
  if (role === 'admin') return i18n.t('role.adminPlatform')
  if (role === 'dispatcher') return i18n.t('role.dispatcher')
  if (role === 'customer_supervisor' && isCustomerUser(profile)) {
    return i18n.t('role.customerSupervisor')
  }
  if (role === 'manager' && isCustomerUser(profile)) {
    return i18n.t('role.customerManager')
  }
  if (role === 'contractor_supervisor' && isContractorUser(profile)) {
    return i18n.t('role.contractorSupervisor')
  }
  if (role === 'inspector' && isContractorUser(profile)) {
    return i18n.t('role.inspector')
  }
  if (role === 'manager') return i18n.t('role.manager')
  if (role === 'customer_supervisor') return i18n.t('role.customerSupervisor')
  if (role === 'contractor_supervisor') return i18n.t('role.contractorSupervisor')
  if (role === 'inspector') return i18n.t('role.inspector')
  if (role === 'partner_operator') return i18n.t('role.partnerOperator')
  if (role === 'partner_viewer') return i18n.t('role.partnerViewer')
  return role
}
